// kyc update

import { CreateResponsiveStyle, DEVICE_SIZES, maxSize,} from "rn-responsive-styles";
import { COLORS, FONTS } from "../../constant";

const useStyles = CreateResponsiveStyle(
  {
    lowBalanceText: {
      fontSize: 8,
      color: COLORS.red,
      fontWeight: "bold",
      // marginLeft: 3,
    }
,    container: {
      backgroundColor: '#fff',
      borderRadius: 11,
      marginLeft: 0,
      width:'100%',
      marginTop:-50
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
  },
  overlayContentViewStyle:{
    width: '50%',
    minHeight: 310,
    marginTop:'-30%',
    borderRadius: 13,
    backgroundColor: "#ffffff",
    shadowColor: "rgba(0, 0, 0, 0.05)",
    shadowOffset: {
        width: 0,
        height: 27,
    },
    shadowRadius: 34,
    shadowOpacity: 1,
  },
  cancelChequeWidget:{
    width:'100%',
    flexDirection:'row',
    alignItems:'center'
  },
  footerUndertaking:{
    flexDirection:'row',
    justifyContent:'center',
    width:'100%',
    marginTop:20,
    marginLeft:20
  },
    closurePolicyWidget: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      backgroundColor: COLORS.lightOrange,
      borderTopLeftRadius: 11,
      borderTopRightRadius: 11,
      alignItems: 'center',
      paddingHorizontal: 30,
      maxHeight: 50
    },
    closurePolicyText:{
      fontFamily:FONTS.Inter,
      fontSize: 16,
      color:COLORS.white,
      maxWidth:'100%'
    },
    closurePolicyTextWidget:{
      flexDirection:'row',
      alignItems:'center'
    },
    cancelBtn: {
      padding: 6,
      marginRight: 12
    },
    closeText: {
      color: COLORS.white,
      fontFamily: FONTS.Inter,
      fontSize: 16,
    },
    closureDocWidget: {
      paddingTop: 25,
      flex: 0.5
    },
    contentWidget: {
      paddingLeft: 70,
      paddingBottom: 40
    },
    navWidget:{
      flexDirection:'row',
      alignItems:'center',
      width:'100%'
    },
    msgWidget:{
      width:'100%',
      marginTop:15,
      flexDirection:'row'
    },
    backTextDesc: {
      fontFamily: FONTS.InterMedium,
      fontSize: 12,
      color: COLORS.darkBlack,
      lineHeight: 21,
      letterSpacing: 0.5,
      paddingLeft: 70,
      paddingRight: 30,
      paddingTop: 6,
  },
    digiBtn: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      paddingHorizontal: 36,
      maxWidth: 180
    },
    docBtn: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      paddingHorizontal: 36,
      maxWidth: 180
    },
    bitMap: {
      width: 51.5,
      height: 47,
      borderRadius: 10,
      backgroundColor: "#ccd0d5",
      marginVerticle: 10,
    },
    selectedCard: {
      backgroundColor: COLORS.white,
      borderRadius: 10,
      borderColor: COLORS.boderColor,
      borderWidth: 1,
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 20,
      paddingVertical: 10,
      minWidth: 270,
      marginTop: 10,marginRight:15
    },
    selectedCardText: {
      marginLeft: 20,
      marginRight: 20
    },
    tollWidget: {
      marginTop: 10,
      alignItems: 'center',

    },
    fullWidth: {
      width: '100%'
    },
    contentSpace: {
      flex: 0.5
    },
    contentSpaceInput:{
      flex: 0.5,
      flexDirection:'row',
      alignItems:'center'
    },
    msgInnerCnt:{
      flex: 0.5
    },
    msgInnerCntTag:{
      flex: 0.5
    },
    bankCntInner:{
      flex: 0.5,
      backgroundColor: COLORS.brownishGrey
    },
    fullWidthContent:{
      flexDirection:'row',
      width: '100%'
    },
    bankNanmDropdown: {
      width: '100%',
      position: 'relative',
      zIndex: 99,
      marginBottom: 10
    },
    otherTextarea: {
      width: '90%',
      minHeight: 60,
      backgroundColor: COLORS.white,
      borderRadius: 11,
      borderWidth: 1,
      borderColor: '#b9b9b9',
      padding: 12,
    },
    dropDownHeader: {
      backgroundColor: "#fff",
      width: 180,
      height: 40,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      paddingHorizontal: 15,
      borderWidth: 1,
      borderColor: "rgba(117, 117, 117, 0.4)",
    },
    dropDownHeaderHide: {
      backgroundColor: "#fff",
      width: 180,
      height: 40,
      borderRadius: 10,
      paddingHorizontal: 15,
      borderWidth: 1,
      borderColor: "rgba(117, 117, 117, 0.4)",
    },
    showDropdown: {
      display: "flex",
      backgroundColor: "#fff",
      borderColor: "#dfdfdf",
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      height: 120,
      overflow: "scroll",
      width: 180,
      position: "absolute",
      top: 40,
      zIndex: 10,
      borderWidth: 1,
    },
    showDropdownAcntType: {
      display: "flex",
      backgroundColor: "#fff",
      borderColor: "#dfdfdf",
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      height: 80,
      overflow: "scroll",
      width: 180,
      position: "absolute",
      top: 40,
      zIndex: 10,
      borderWidth: 1,
    },
    closeTagBtn: {
      width: 120,
      alignSelf: 'flex-end',
      marginRight: 70
    },
    backBtn: {
      width: 150,
      backgroundColor: COLORS.white,
      borderWidth: 1,
      borderColor: COLORS.red,
      marginRight: 15,
      marginTop: 12,
      color: COLORS.red,
      height: 36,
      borderRadius: 23,
      alignItems: 'center',
      justifyContent: 'center'
    },
    panText: {
      marginRight: 60
    },
    verifyText: {
      position: 'relative',
      right: 60
    },
    verifiedText: {
      position: 'relative',
      right: 85,
      flexDirection: 'row'
    },
    inputFileBox: {
      height: 42,
      borderWidth: 1,
      borderColor: COLORS.gray300,
      borderRadius: 10,
      alignSelf: 'flex-end'
    },
    inputFileBoxIconCloseWidget: {
      backgroundColor: COLORS.red,
      borderRadius: 15,
      height: 30,
      width: 30
    },
    inputFileBoxIconWidget: {
      backgroundColor: COLORS.gray300,
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      height: 40,
      width: 60,
      position: 'relative',
      zIndex: 999
    },
    inputFileBoxText: {
      paddingHorizontal: 12,
      opacity: 0.6,
      fontWeight: '500'
    },
    closeIcon: {
      position: 'absolute',
      left: 75,
      top: 4,
      zIndex: 9,
      backgroundColor: COLORS.red,
      borderRadius: 10,
      width: 20,
      height: 20,
      alignItems: 'center',
      justifyContent: 'center'
    },
    closeIconChequeImg: {
      position: 'absolute',
      right: 5,
      top: 4,
      zIndex: 9,
      backgroundColor: COLORS.red,
      borderRadius: 10,
      width: 20,
      height: 20,
      alignItems: 'center',
      justifyContent: 'center'
    },
    imagePrevStyle: {
      width: 100,
      height: 100,
      borderRadius: 10,
      borderStyle: 'dashed',
      borderWidth: 1,
      borderColor: COLORS.boderColor
    },
    containerLoader: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.5)',
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: 99,
      left: 40
    },
    hotlistPopup: {
      width: 180,
      height: 50,
      backgroundColor: COLORS.white,
      borderRadius: 6,
      borderWidth: 1,
      borderColor: 'rgba(204, 208, 213, 0.3)',
      position: 'absolute',
      top: 0,
      left: 30,
      padding: 12,
      zIndex: 999
    },
    digilockIconPosition: {
      position: 'absolute',
      top: 14,
      right: 10,
      zIndex: 99
    },
    bankAcntInput:{
      borderRadius: 10,
    backgroundColor:'white',
    borderWidth: 1,
    borderColor: "#ccc",
    marginBottom: 5,
    paddingLeft: 20,
    color: '#757575',
    fontFamily: 'Inter',
    fontSize: 14,
    height: 40,
    width:'37%',
    },
    digiVerifyText:{
      opacity: 0.6,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 15
    },
    smsText:{
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 15
    },
    indicatotWrapper:{
      width: 323,
      height: 192,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27
      },
      shadowRadius: 34,
      shadowOpacity: 1,
      alignItems: "center",
      justifyContent: "center"
    },
    ButtonWidget:{
      marginTop: 105,
      paddingRight: 50,
    },
    WarningWidget:{
      marginTop: 0,
    }

  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {

    },

    [maxSize(DEVICE_SIZES.MD)]: {
      container: {
        height: "default",
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },
      otherTextarea:{marginTop : 170},
      closurePolicyWidget:{
        minHeight:130,
        paddingVertical:8
      },
      closurePolicyText:{
        fontSize: 13,
        maxWidth:200,
      },
      contentWidget:{
        paddingLeft:20
      },
      navWidget:{
        flexDirection:'column'
      },
      msgWidget:{
        flexDirection:'column'
      },
      msgInnerCnt:{
        width:'100%',
        flex:1,
      },
      msgInnerCntTag:{
        width:'100%',
        flex:1,
        minHeight:170
      },
      bankCntInner:{
        width:'100%'
      },
      selectedCard:{
        minHeight:100
      },
      backTextDesc: {
        paddingLeft: 20,
        paddingRight: 0,
        fontSize:10
    },
    contentSpaceInput:{
      flexDirection:'column',
      alignItems:'flex-start'
    },
    overlayViewStyle:{
      left:0
    },
    overlayContentViewStyle:{
      width:'100%'
    },
    ButtonWidget:{
      marginTop: 10,
      alignSelf: 'flex-start',
    },

    },
    [DEVICE_SIZES.XS]:
    {
      container: {
        marginLeft: 0,
        width:'100%',
        maxWidth:'100%'
      },
      closurePolicyWidget:{
        minHeight:130,
        paddingVertical:8
      },
      closurePolicyText:{
        fontSize: 14,
        maxWidth:180,
      },
      contentWidget:{
        paddingLeft:20
      },
      navWidget:{
        flexDirection:'column'
      },
      msgWidget:{
        flexDirection:'column'
      },
      msgInnerCnt:{
        width:'100%',
        flex:1,
      },
      msgInnerCntTag:{
        width:'100%',
        flex:1,
        minHeight:170
      },
      
      bankCntInner:{
        width:'100%'
      },
      selectedCard:{
        minHeight:100
      },
      backTextDesc: {
        paddingLeft: 20,
        paddingRight: 0,
        fontSize:10
    },
    contentSpaceInput:{
      flexDirection:'column',
      alignItems:'flex-start'
    },
    overlayViewStyle:{
      left:0
    },
    overlayContentViewStyle:{
      width:'100%'
    },
    cancelChequeWidget:{
      marginLeft:-10
    },
    ButtonWidget:{
      marginTop: 10,
      alignSelf: 'flex-start',
    },
    WarningWidget:{
      width: "100%"
    }
    },

  }
);

export default useStyles;
